"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const ITEMS = ["expertSupportCard1", "expertSupportCard2", "expertSupportCard3"] as const;

const IMAGE = "/image/new-version/ValueAddedSolutions/industrial-automation/expert-team-support.webp";

const CheckIcon = () => (
	<span
		className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-themePrimary400 text-white"
		aria-hidden="true"
	>
		<svg viewBox="0 0 16 16" className="h-3 w-3" fill="none">
			<path
				d="M3.5 8.3 6.4 11 12.5 5"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</span>
);

export default function IndustrialAutomationExpertSupport() {
	const t = useTranslations("new-industrial-automation");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("expertSupportTitle")}
					</h2>
				</header>

				<div className="grid gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:items-center lg:gap-10">
					<div>
						<div className="relative aspect-[4/3] overflow-hidden rounded-lg bg-[#f5f7fa]">
							<Image
								src={IMAGE}
								alt={t("expertSupportImageAlt")}
								fill
								className="object-cover"
								sizes="(max-width: 1024px) 100vw, 50vw"
							/>
						</div>
						<Link
							href="/contact-us"
							className="mt-6 inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] hover:text-white md:px-8 md:py-3.5 md:text-base"
						>
							{t("expertSupportContact")}
						</Link>
					</div>

					<div className="space-y-6">
						{ITEMS.map((keyPrefix) => (
							<article key={keyPrefix} className="flex gap-3">
								<CheckIcon />
								<div>
									<h3 className="mb-3 text-lg font-bold leading-tight text-black sm:text-xl md:text-2xl">
										{t(`${keyPrefix}Title`)}
									</h3>
									<p className="text-sm leading-relaxed text-black md:text-base">{t(`${keyPrefix}Desc`)}</p>
								</div>
							</article>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
